module.exports = "<div class=\"card toggle-button session-student-label small-grey-text\" draggable=\"true\">\n  <p data-bind-target=\"student-label-name\"></p>\n\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/views/partials/sessions/session-student-label.html
// module id = 644
// module chunks = 1